
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-svg_marker_library",
  "use": "icon-rescls-svg_marker_library-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-rescls-svg_marker_library\"><path fill=\"#81B0DC\" d=\"M25.5 4h-19a2.5 2.5 0 0 0-2.45 2H24a2 2 0 0 1 2 2v19.95a2.5 2.5 0 0 0 2-2.45v-19A2.5 2.5 0 0 0 25.5 4\" /><path fill=\"#DCE8F3\" d=\"M29.5 0h-19a2.5 2.5 0 0 0-2.45 2H28a2 2 0 0 1 2 2v19.95a2.5 2.5 0 0 0 2-2.45v-19A2.5 2.5 0 0 0 29.5 0\" /><path fill=\"#3498DB\" d=\"M17.03 20.51c-.129 2.116-1.087 3.946-2.789 5.297-1.784 1.417-4.307 2.19-6.941 2.19-.823 0-1.657-.076-2.484-.231a1 1 0 0 1-.253-1.882c1.208-.588 1.576-1.7 2.077-3.466.687-2.425 1.546-5.436 6.382-5.913.78-2.578 2.959-5.177 7.163-8.505H2.5A2.5 2.5 0 0 0 0 10.5v19A2.5 2.5 0 0 0 2.5 32h19a2.5 2.5 0 0 0 2.5-2.5V15.203c-2.621 3.009-4.803 4.652-6.97 5.307\" /><path fill=\"#AEC8E0\" d=\"M21.783 8.028c-4.103 3.128-6.977 5.968-7.817 8.805l2.734 2.734c2.376-.704 4.754-2.841 7.301-5.921V10.5a2.494 2.494 0 0 0-2.218-2.472\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-svg_marker_library"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-svg_marker_library";

        export default Icon;
    